@if (channels.length) {
  <slb-panel-list (openedChange)="onOpenChanged($event)" class="channel-list">
    <slb-panel-list-title class="slb-panel-list-title">
      <div class="channel-list__filter">
        <unit-system-switcher
          (unitSystemSelected)="changeUnitSystem($event)">
        </unit-system-switcher>
      </div>
      <span class="channel-list__title">{{title}}</span>
      <div class="channel-list__filter">
        <button
          slb-secondary-button
          class="channel-list__filter-button"
          [disabled]="disableDeselectAll || disabled"
          (click)="deselectAll()">
          <mat-icon [svgIcon]="'reset'"></mat-icon>
          <span>Deselect All</span>
        </button>
        <mat-list>
          @if (!hideSelectDefault) {
            <mat-list-item class="channel-list__filter-checkbox">
              <mat-checkbox
                color="primary"
                matLine
                name="selectDefaultChannels"
                [disabled]="disabled"
                (change)="onSelectDefault()"
                [(ngModel)]="selectDefaultChannels">
                Select Default Channels
              </mat-checkbox>
            </mat-list-item>
          }
        </mat-list>
      </div>
      <div class="channel-list__filter">
        <mat-form-field class="channel-list__search" slbFormField>
          <input matInput [placeholder]="'Start Typing...'" [(ngModel)]="searchText"/>
        </mat-form-field>
      </div>
    </slb-panel-list-title>
    <mat-list>
      <cdk-virtual-scroll-viewport itemSize="40" [style.width.px]="virtualScrollWidth" class="viewport">
        <div *cdkVirtualFor="let channel of channels | filterByInputString : searchText : 'displayName'; trackBy: trackByFn"
          [style.height.px]="40">
          @if (channel) {
            <mat-list-item
              class="channel-list__checkbox"
              [matTooltipDisabled]="channel.isAvailable !== false"
              [slbTooltip]="channel.isAvailable === false && channel.issues[0]?.message">
              <mat-checkbox
                color="primary"
                matLine
                name="channelList"
                [disabled]="channel.isAvailable === false || channel.disabled || disabled"
                (change)="onChannelListChanged($event, channel.name)"
                [checked]="channel.selected"
                [(ngModel)]="channel.selected">
                <ng-container [ngTemplateOutlet]="checkboxContent"></ng-container>
              </mat-checkbox>
              <ng-template #checkboxContent>
                <div fxLayout="row" fxLayoutAlign="space-between baseline">
                  <div>
                    <span
                      class="channel-list__checkbox-label"
                      [matTooltipDisabled]="channel.displayName?.length < 16"
                      [slbTooltip]="channel.displayName">
                      {{channel.displayName}}
                    </span>
                    <span class="channel-list__checkbox-unit">
                      {{channel.label}}
                    </span>
                  </div>
                </div>
              </ng-template>
            </mat-list-item>
          }
        </div>
      </cdk-virtual-scroll-viewport>
    </mat-list>
  </slb-panel-list>
}
